// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var LinkedPriceType;
(function (LinkedPriceType) {
    LinkedPriceType[LinkedPriceType["None"] = 0] = "None";
    LinkedPriceType[LinkedPriceType["Bid"] = 1] = "Bid";
    LinkedPriceType[LinkedPriceType["Ask"] = 2] = "Ask";
    LinkedPriceType[LinkedPriceType["Last"] = 3] = "Last";
})(LinkedPriceType || (LinkedPriceType = {}));
